module.exports = __webpack_public_path__ + "static/img/brand-value-1.7c349d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-culture/brand-value-1.png
// module id = Gcyp
// module chunks = 1